import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    orgId,
    depCateId,
    depId,
    userId,
    industryId,
    search,
    filters = [],
    order = [],
    pi = 1,
    ps = 50,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.projKpi.getPage, {
        orgId,
        depCateId,
        depId,
        userId,
        industryId,
        search,
        filters,
        order,
        pi,
        ps,
    }, options);
    if (error) return { error, status };
    return content || { rows: [], total: 0, pc: 0, ps, pi };
};
